import type {
  Action,
  DataRoute,
  List,
  Outcome,
  PublishedAttribute,
  ReasonCodeGroup,
  ServiceObject,
  Tag,
  Threshold,
  WorkflowFailureHandlingMode,
  WorkflowType,
} from 'flow/store/engine/types';
import type { APIClient } from '../../apiClient';
import { workflowRoutes } from './workflowRoutes';
import type { SdkConfigPayload } from
  'flow/editor/components/MenuBar/MenuBarModals/ThreeDotsModals/SDKConfigModal/types';

export type WorkflowSchema = {
  name: string;
  token: string;
  workflowType: WorkflowType;
  actions: Record<string, Action>;
  thresholds: Record<string, Threshold>;
  dataRoutes: Record<string, DataRoute>;
  failureHandlingMode: WorkflowFailureHandlingMode;
  sdkConfig: SdkConfigPayload;
};

export type CreateWorkflowVersionPayload = {
  workflowVersion: WorkflowSchema;
  workflowVersionMetadata: {
    changes: string;
    notes: string;
    parentPublicVersion: number | null;
  };
  snippetVersion?: {
    props: {
      tags: Tag[];
      outcomes: Outcome[];
      services: ServiceObject[];
      publishedAttributes: PublishedAttribute[];
      reasonCodeGroups: ReasonCodeGroup[];
      lists: List[];
    };
  };
  accountArtifacts: {
    services: ServiceObject[];
  };
};

export default function createWorkflowsAPI(apiClient: APIClient) {
  return {
    versions: {
      // todo - add return type when API contract is finalized
      createWorkflowVersion: async (
        data: CreateWorkflowVersionPayload,
      ) => apiClient.post(
        workflowRoutes.workflowVersion(
          data.workflowVersion.token,
        ),
        data,
        {
          meta: {
            skipTransformRequestBody: true,
            skipTransformResponseBody: true,
          },
        },
      ),
    },
  };
}
